/*
  LW Variant-Media Hero-Handler (2026-07)
  ------------------------------------------------------------------
  Zwei getrennte Verantwortlichkeiten:

  A) GENERISCH (auf JEDER Produktseite): interner Galerie-Scroll-Reset.
     Der Custom-Loongway-Layoutstil (base.css @media min-width:990px) macht
     .product__media-wrapper zu einem INTERN scrollenden Container
     (position:sticky; height:calc(100vh-140px); overflow-y:auto). Beim
     Farbwechsel ordnet Dawn das Variantenbild korrekt als erstes li, laesst
     aber .product__media-wrapper.scrollTop unveraendert -> der Kunde bleibt an
     der alten Scrollposition. Deshalb wird der interne Scroll bei einem echten
     Variantenwechsel (Dawn-PubSub variantChange) UND bei jedem nativen
     Farbswatch-Klick auf 0 gesetzt. (Der Zepto-Farbwechsel-Reset laeuft separat
     ueber theme.liquid.)

  B) HERO-SPEZIFISCH (nur wenn die Map #lw-hero-media-map vorhanden ist, aktuell
     nur die 750-ml-Flasche): No-op-Sonderfall — Klick auf die BEREITS aktive
     Variante feuert in Dawn kein change-Event; dann aktivieren wir das
     Variantenmedium selbst via media-gallery.setActiveMedia().

  Kein MutationObserver, keine Timeout-Ketten: ein delegierter click-Listener +
  der Dawn-PubSub-Hook. Zepto-Sync/ATC unberuehrt.
*/
(function () {
  'use strict';

  if (window.__lwVariantMediaHeroInit) return; // Doppel-Init verhindern
  window.__lwVariantMediaHeroInit = true;

  function init() {
    // --- Hero-Map: nur auf dem gegateten Produkt vorhanden (optional) ---
    var byValue = {};
    var mapEl = document.getElementById('lw-hero-media-map');
    if (mapEl) {
      try {
        (JSON.parse(mapEl.textContent).variants || []).forEach(function (v) {
          if (v && v.value && v.media && v.id) {
            byValue[String(v.value).trim().toLowerCase()] = { media: v.media, id: String(v.id) };
          }
        });
      } catch (e) {}
    }
    var hasMap = Object.keys(byValue).length > 0;

    function currentVariantId(productInfo) {
      var input =
        (productInfo && productInfo.querySelector('input[name="id"]')) ||
        document.querySelector('product-info input[name="id"]') ||
        document.querySelector('input[name="id"]');
      return input ? String(input.value) : null;
    }

    // GENERISCH: internen Galerie-Scrollcontainer (.product__media-wrapper) an den
    // Anfang. Das ist der real scrollende Container, NICHT das Fenster.
    function resetGalleryScroll(productInfo) {
      var wrapper =
        (productInfo && productInfo.querySelector('.product__media-wrapper')) ||
        document.querySelector('.product__media-wrapper');
      if (wrapper && wrapper.scrollTop !== 0) wrapper.scrollTop = 0;
    }

    // GENERISCH: nach einem echten Variantenwechsel (Dawn ordnet Media neu, setzt
    // aber scrollTop nicht zurueck). variantChange feuert NACH updateMedia.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        resetGalleryScroll(document.querySelector('product-info'));
      });
    }

    // Ein delegierter Klick-Listener: generischer Reset bei jedem nativen
    // Farbswatch-Klick + (nur mit Map) Hero-No-op-Media-Aktivierung.
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        var input = t.closest('input[type="radio"]');
        if (!input) {
          var lbl = t.closest('label');
          if (lbl) {
            var forId = lbl.getAttribute('for');
            input = (forId && document.getElementById(forId)) || lbl.querySelector('input[type="radio"]');
          }
        }
        if (!input || input.type !== 'radio') return;
        var vs = input.closest('variant-selects');
        if (!vs) return;
        var productInfo = vs.closest('product-info');

        // HERO-SPEZIFISCH: No-op-Fall (geklickte Farbe == aktuell aktive Variante).
        if (hasMap) {
          var entry = byValue[String(input.value).trim().toLowerCase()];
          if (entry) {
            var gallery = (productInfo && productInfo.querySelector('media-gallery')) || document.querySelector('media-gallery');
            if (entry.id === currentVariantId(productInfo) && gallery && typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(entry.media, true);
            }
          }
        }

        // GENERISCH: internen Galerie-Scroll an den Anfang.
        resetGalleryScroll(productInfo);
      },
      false
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
